(function () {

    function getSizeLabelFromTags(tags) {
        if (!Array.isArray(tags)) {
            return "";
        }

        const hasCircle = tags.some((tag) => String(tag).toLowerCase() === "size:circle");
        if (hasCircle) return "Circle";
    
        const sizeTags = tags.filter((tag) => {
            return String(tag).toLowerCase().indexOf("size") !== -1;
        });
    
        if (!sizeTags.length) {
            return "";
        }
    
        const sizeTag = sizeTags[sizeTags.length - 1];
    
        const parts = String(sizeTag)
            .split(":").pop()
            .split("-").shift()
            .split("_");
    
        return parts[0] || "";
    }
    
    function renderLinkedColumns(container) {
        const handleString = container.getAttribute("data-linked-handles");
        if (!handleString || !handleString.trim()) {
            return;
        }
        const handles = handleString.split(",").map((h) => {
            return h.trim();
        }).filter(Boolean);
        if (!handles.length) {
            return;
        }

        container.removeAttribute("hidden");
        container.setAttribute("aria-busy", "true");

        const fetches = handles.map(function (handle) {
            return fetch("/products/" + encodeURIComponent(handle) + ".js").then((res) => {
                return res.ok ? res.json() : null;
            }).catch(() => {
                return null;
            });
        });

        Promise.all(fetches).then((products) => {
            container.removeAttribute("aria-busy");
            products.forEach((product) => {
                if (!product || !product.variants || !product.variants.length) return;
                const sizeLabel = getSizeLabelFromTags(product.tags || []);
                const column = document.createElement("div");
                column.className = "product-variants-column";
                column.innerHTML =
                    '<div class="product-variants-heading">' + (sizeLabel ? escapeHtml(sizeLabel) : '') + '</div>' +
                    '<div class="product-variants-options">' +
                    product.variants.map(function (v) {
                    const url = '/products/' + encodeURIComponent(product.handle) + '?variant=' + v.id;
                    const extraClass = v.available ? '' : ' product-variants-option--out-of-stock';
                    const title = escapeHtml(v.title);
                    const label = v.available ? title : title + ' (Out of stock)';
                    return '<a href="' + url + '" class="product-variants-option' + extraClass + '">' + label + '</a>';
                    }).join("") +
                    '</div>';
                container.appendChild(column);
            });
        });
    }

    function escapeHtml(s) {
      const div = document.createElement('div');
      div.textContent = s;
      return div.innerHTML;
    }
  
    function init() {
        const variantSections = document.querySelectorAll(".product-variants:has(.product-variants-linked[data-linked-handles])");
        if (!variantSections.length) {
            return;
        }

        const observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting) return;
                    const section = entry.target;
                    observer.unobserve(section);
                    const container = section.querySelector(".product-variants-linked[data-linked-handles]");
                    if (container) renderLinkedColumns(container);
                });
            },
            { rootMargin: "50px", threshold: 0 }
        );

        variantSections.forEach(function (section) {
            observer.observe(section);
        });
    }
    
    if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
    } else {
    init();
    }
})();